/*
 * @Description : 表单验证
 * @Author      : pishengjun
 * @Date        : 2022-08-02 18:35:22
 */

export const validator = {
  // 姓名校验
  userName: (rule, value) => {
    // 扩展 Unicode 范围并启用多码位支持，该正则可覆盖现代中文姓名中的绝大多数汉字（包括生僻字和扩展字符）。
    // 张贺䶮	      ✔️ 匹配	包含扩展A区汉字
    // 欧阳·娜娜  	✔️ 匹配	含中间点符号
    // 李四	        ✔️ 匹配	基本汉字
    // 123	        ❌ 不匹配	包含非汉字字符
    // （空字符串）	 ❌ 不匹配
    const reg = /^[\u3400-\u4DBF\u4E00-\u9FA5·]*$/g;
    if (value && value.length < 2) return Promise.reject("姓名至少需2个以上字符");
    if (value && !reg.test(value)) return Promise.reject("请输入中文姓名");
    return Promise.resolve();
  },
  // 手机号码校验
  validatePhone: (rule: any, value: string) => {
    const reg = new RegExp(/^1[3-9]\d{9}$/g);
    if (value && !reg.test(value)) {
      return Promise.reject("请输入正确的手机号码");
    } else {
      return Promise.resolve();
    }
  },
  // 身份证号码校验
  IDCardValidator: (rule: any, idcode: string) => {
    if (idcode == "") {
      return Promise.resolve();
    }
    const idcard_patter = new RegExp(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/);
    // 判断格式是否正确
    const format = idcard_patter.test(idcode);
    if (!format) {
      return Promise.reject("身份证号码格式错误");
    }
    // 加权因子
    const weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验码
    const check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
    const last = idcode[17].toUpperCase(); //最后一位
    const seventeen = idcode.substring(0, 17);
    // ISO 7064:1983.MOD 11-2
    // 判断最后一位校验码是否正确
    const arr: any[] = seventeen.split("");
    const len = arr.length;
    let num: any = 0 as any;
    for (let i = 0; i < len; i++) {
      num += arr[i] * weight_factor[i];
    }
    // 获取余数
    const resisue = num % 11;
    const last_no = check_code[resisue];
    // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
    const result = last === last_no ? true : false;
    if (!result) return Promise.reject("身份证号码格式错误");
    return Promise.resolve();
  },
  // 密码校验 (必须包含数字、小写或大写字母、特殊字符、长度8-30位)
  password: (rule, value) => {
    const reg = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*]).{8,30}$/);
    if (value && !reg.test(value)) {
      return Promise.reject("必须同时包含数字、大写或小写字母、特殊字符(~!@#$%^&*) 3种类型，并且长度为8-30位");
    } else {
      return Promise.resolve();
    }
  },
};
